import React from "react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const AboutFaq = () => {
  const { t } = useLang();
  return (
    <section id="ueber-uns" className="scroll-mt-24 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
              {t.about.badge}
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
              {t.about.title}
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-petrol-soft">
              {t.about.text}
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              {t.about.stats.map((s) => (
                <div key={s.v} className="rounded-2xl bg-cream p-5">
                  <p className="font-heading text-3xl font-extrabold text-terracotta">
                    {s.k}
                  </p>
                  <p className="mt-1 text-sm font-semibold text-petrol-soft">
                    {s.v}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
